import { render } from "./NewsPublicationDate.vue?vue&type=template&id=4be2607a"
import script from "./NewsPublicationDate.vue?vue&type=script&lang=js"
export * from "./NewsPublicationDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__